export default __webpack_public_path__ + "static/media/Star.ac63fd12.svg";